import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBadges = () => {
  const badges = [
    {
      icon: 'Shield',
      title: 'SOC 2 Type II',
      description: 'Certified'
    },
    {
      icon: 'Lock',
      title: 'Bank-Grade',
      description: 'Encryption'
    },
    {
      icon: 'CheckCircle',
      title: 'PCI DSS',
      description: 'Compliant'
    },
    {
      icon: 'Eye',
      title: 'GDPR',
      description: 'Protected'
    }
  ];

  return (
    <div className="space-y-4 md:space-y-6">
      <div className="text-center">
        <h3 className="text-sm md:text-base font-semibold text-foreground mb-2">Enterprise-Grade Security</h3>
        <p className="text-xs md:text-sm text-muted-foreground">Your financial data is protected by industry-leading security standards</p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
        {badges?.map((badge, index) => (
          <div
            key={index}
            className="p-3 md:p-4 bg-card border border-border rounded-lg text-center hover:border-primary hover:shadow-elevation-2 transition-smooth"
          >
            <div className="inline-flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-full bg-primary/10 mb-2 md:mb-3">
              <Icon name={badge?.icon} size={20} color="var(--color-primary)" className="md:w-6 md:h-6" />
            </div>
            <p className="text-xs md:text-sm font-semibold text-foreground">{badge?.title}</p>
            <p className="text-xs text-muted-foreground mt-1">{badge?.description}</p>
          </div>
        ))}
      </div>
      <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 pt-2 md:pt-4 border-t border-border">
        <div className="flex items-center gap-2">
          <Icon name="Server" size={16} color="var(--color-success)" />
          <span className="text-xs md:text-sm text-muted-foreground">99.9% Uptime</span>
        </div>
        <div className="flex items-center gap-2">
          <Icon name="Zap" size={16} color="var(--color-success)" />
          <span className="text-xs md:text-sm text-muted-foreground">Real-time Sync</span>
        </div>
        <div className="flex items-center gap-2">
          <Icon name="Globe" size={16} color="var(--color-success)" />
          <span className="text-xs md:text-sm text-muted-foreground">Global CDN</span>
        </div>
      </div>
    </div>
  );
};

export default SecurityBadges;